import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <section className="min-h-[70vh] bg-gray-50 pt-32 pb-20">
    <div className="max-w-2xl mx-auto px-4 text-center">
      <p className="text-airmax-blue font-bold text-lg">404</p>
      <h1 className="mt-2 text-4xl font-bold text-gray-900">Page not found</h1>
      <p className="mt-4 text-gray-600">
        The page you requested does not exist or may have moved.
      </p>
      <Link
        to="/"
        className="inline-flex mt-8 px-6 py-3 rounded-lg bg-airmax-blue text-white font-bold hover:bg-blue-700"
      >
        Return home
      </Link>
    </div>
  </section>
);

export default NotFound;
